@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@remover-width: 12px;
@remover-margin: 4px;

.editor-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  &:nth-child(odd) {
    background-color: @filter-editor--wrapper--background-color;
    border-radius: 2px;
  }
}

.editor-columns {
  > div {
    padding: 4px;
    &:last-of-type {
      padding-right: 0;
    }
  }
  width: calc(100% ~'-' @remover-width ~'+' @remover-margin);
  display: grid;
  grid-template-columns: 33.3% 33.3% 33.4%;
}

button.highlighted-template-input,
.highlighted-template-input input {
  outline: 1px solid var(--blue-500);
}

.missing-editor {
  width: 100%;
  text-align: center;
  padding: 10px;
}

.filter-remover-wrap {
  display: flex;
  align-items: center;
  padding: 0;
}

.filter-remover {
  height: @remover-width;
  width: @remover-width;
  min-width: @remover-width;
  display: flex;
  margin: @remover-margin;
  cursor: pointer;
  .icon {
    color: @filter-editor--remover--text-color;
    height: 100%;
    width: 100%;
  }
  &:hover {
    .icon {
      color: @filter-editor--remover--hover--text-color;
    }
  }
}
